/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    export class FormJsonDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return FormJsonForm.formKey; }
        protected form = new FormJsonForm(this.idPrefix);
        public item: FormObject[] = [];
        constructor() {
            super();
        }
        protected updateTitle() {
            this.dialogTitle = "Import Form Json"
        }
        public callback = (string) => {

        }
        mappingObjectToForm(item: FormObject) {
            var result: FormRow = {};
            result.Name = item.Name;
            result.ProductId = item.ProductId;
            result.Type = item.Type;
            result.SuccessType = item.SuccessType;
            result.SuccessData = item.SuccessData != null ? JSON.stringify(item.SuccessData) : null;
            result.TagIds = item.Tags;
            result.Data = item.Data != null ? JSON.stringify(item.Data) : null;
            result.Payment = item.Payment;
            result.Layout = item.Layout;
            result.HLogo = item.HLogo;
            result.HData = item.HData != null ? JSON.stringify(item.HData) : null;
            result.BData = item.BData != null ? JSON.stringify(item.BData) : null;
            result.ShowLabel = +item.ShowLabel;
            result.ShowCaptcha = +item.ShowCaptcha;
            result.ShowCoupon = +item.ShowCoupon;
            result.IsSendWa = +item.IsSendWa;
            result.IsSendMail = +item.IsSendMail;
            result.DataWa = item.DataWa != null ? JSON.stringify(item.DataWa) : null;
            result.DataMail = item.DataMail != null ? JSON.stringify(item.DataMail) : null;
            return result;
        }
        mappingFormToObject(item: FormRow) {
            var result: FormObject = {};
            result.Name = item.Name;
            result.ProductId = item.ProductId;
            result.Type = item.Type;
            result.SuccessType = item.SuccessType;
            result.SuccessData = !Q.isEmptyOrNull(item.SuccessData) ? JSON.parse(item.SuccessData) : null;
            result.Tags = item.TagIds;
            result.Data = !Q.isEmptyOrNull(item.Data) ? JSON.parse(item.Data) : null;
            result.Payment = item.Payment;
            result.Layout = item.Layout;
            result.HLogo = item.HLogo;
            result.HData = !Q.isEmptyOrNull(item.HData) ? JSON.parse(item.HData) : null;
            result.BData = !Q.isEmptyOrNull(item.BData) ? JSON.parse(item.BData) : null;
            result.ShowLabel = Boolean(item.ShowLabel);
            result.ShowCaptcha = Boolean(item.ShowCaptcha);
            result.ShowCoupon = Boolean(item.ShowCoupon);
            result.IsSendWa = Boolean(item.IsSendWa);
            result.IsSendMail = Boolean(item.IsSendMail);
            result.DataWa = !Q.isEmptyOrNull(item.DataWa) ? JSON.parse(item.DataWa) : null;
            result.DataMail = !Q.isEmptyOrNull(item.DataMail) ? JSON.parse(item.DataMail) : null;
            return result;
        }
        protected updateInterface() {
            super.updateInterface();
            var $this = this;
            var table = this.element.find(".tbFormImport tbody");
            table.html("");
            this.item.forEach((x, index) => {
                var row = $("<tr></tr>")
                var colName = $("<td></td>");
                colName.text(x.Name);
                colName.appendTo(row)

                var colValid = $("<td></td>");
                colValid.text(x.IsValid ?"✅":"❌");
                colValid.appendTo(row)

                var colAction = $(`<td class="text-center"></td>`);
                var buttonEdit = $(`<button class="btn btn-primary"><i class="fa fa-edit"></i>Edit</button>`);
                buttonEdit.on("click", function () {
                    const Index = index;
                    var dlg = new FormDialog();
                    dlg.isFormImport = true;
                    dlg.importCallback = (res) => {
                        var Old = $this.item[Index];
                        if (Old.Name != res.Name) {
                            $(this).parents("tr").children().first().text(res.Name);
                        }
                        
                        $this.item[Index] = $this.mappingFormToObject(res);
                        $this.item[Index].IsValid = true;
                    }
                    dlg.loadEntityAndOpenDialog($this.mappingObjectToForm($this.item[Index]))
                    $(this).parents("tr").children().eq(1).text("✅");
                })
                var buttonDelete = $(`<button class="btn btn-danger ml-2" title="delete form"><i class="fa fa-trash"></i></button>`);
                buttonDelete.on("click", function (){
                    const Index = index;
                    $(this).parents("tr").remove();
                    $this.item.splice(Index, 1);
                })
                colAction.append(buttonEdit);
                colAction.append(buttonDelete);
                colAction.appendTo(row);
                table.append(row);
            });
        }
        protected setCallback() {
            var $this = this;
            var arrSave: string[] = [];
            this.item.forEach(x => {
                if (x.IsValid) {
                    arrSave.push(JSON.stringify($this.mappingObjectToForm(x)));
                }
            });
            var dlg = new JsonBulkAction();
            dlg.done = () => {
                $this.dialogClose();
            };
            dlg.execute(arrSave);
        }
        protected getToolbarButtons() {
            var $this = this;
            var btn = super.getToolbarButtons();
            btn[0].cssClass = "ImportBtn";
            //btn[0].visible = false;
            btn[0].onClick = function () {
                if ($this.item.length != 0) {
                    $this.setCallback();
                } else {
                    Q.notifyError("Import has no data");
                }
            };
            btn[1].title = "Cancel";
            btn[1].hint = "Cancel";
            btn[1].cssClass = "CancelImport";
            btn[1].visible = false;
            btn[1].icon = "fa-times text-red";
            btn[1].onClick = function () {
                $this.dialogClose();
            };
            btn[2].visible = false;
            btn[3].visible = false;
            btn[4].visible = false;
            btn[5].visible = false;
            return btn;
        }

        getTemplate() {
            return `<div id="~_FormJson" class="s-DialogContent">
                        <div id="~_Toolbar" class="s-DialogToolbar">
                        </div>
                        <div class="s-Form">
                            <table class="tbFormImport table table-striped table-bordered dataTable mt-2" data-auto-responsive="false">
                                <thead>
                                    <tr class="nk-tb-item nk-tb-head">
                                        <th class="nk-tb-col"><span class="sub-text">Form</span></th>
                                        <th class="nk-tb-col"><span class="sub-text">Valid</span></th>
                                        <th class="nk-tb-col"><span class="sub-text text-center">Action</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colspan="6" class="dataTables_empty">Loading data from server</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>`
        }
    }
}